import { Component, OnInit } from '@angular/core';
import { Guard } from '../../../../core/services/guard.service';


@Component({
    selector: 'itpx-account-data-dashboard',
    templateUrl: './account-data-dashboard.component.html'
})
export class AccountDataDashboardComponent {

    constructor(private guard: Guard) {}

    private tiles: Array<any> = [
        {
            title: 'Organizations',
            redirectPath: 'accounts',
            description: 'Manage Organizations',
            icon: 'fa-handshake',
            permission: 'agora.account-data.accounts'
        }, {
            title: 'Employees',
            redirectPath: 'employees',
            description: 'Manage Employees',
            icon: 'fa-user-check',
            permission: 'agora.account-data.employees'
        }, {
            title: 'Communication Data',
            redirectPath: 'communication',
            description: 'Manage Communication Data',
            icon: 'fa-address-card',
            permission: 'agora.account-data.addresses'
        }, 
        {
            title: 'Credit Applications',
            redirectPath: 'credit',
            description: 'Manage Credit Applications',
            icon: 'fa-usd-circle',
            permission: 'agora.account-data.credit'
        }
    ];
}


// WEBPACK FOOTER //
// ./src/app/agora/components/account-data/dashboard/account-data-dashboard.component.ts